import classcat from "classcat";
import React, { SyntheticEvent } from "react";

import css from "./ToolItem.module.css";
import useManageToolItem from "./hooks/useManageToolItem";

type Props = {
  title: string;
  description: string;
  onClick: (e: SyntheticEvent) => void;
  icon?: JSX.Element;
};

const BREAKPOINT_WIDTH = 900;

const ToolItem = ({ title, description, onClick, icon }: Props) => {
  const { handleClick, windowWidth } = useManageToolItem({ onClick });

  return (
    <div className={css.container} onClick={handleClick}>
      <div
        className={classcat([
          { "text-headline-4xl": windowWidth > BREAKPOINT_WIDTH },
          { "text-headline-3xl": windowWidth <= BREAKPOINT_WIDTH },
        ])}
      >
        {title}
      </div>
      <div className={classcat(["text-label-lg", css.description])}>
        {description}
      </div>
      <div className={classcat(["text-headline-4xl", css.iconContainer])}>
        {icon}
      </div>
    </div>
  );
};

export default ToolItem;
